import Store from './index';
import i18n from '../i18n';
import { reset } from '../utils/vuex';
import { makeAuthPlugin } from '../feathers-client';
import { until } from '../utils';

export default {
  plugin: makeAuthPlugin({
    userService: 'users',
  }),

  store: {
    auth: {
      namespaced: true,

      mutations: {
        clearAll: reset(),
      },

      actions: {
        async login({ dispatch }, { user }) {
          await dispatch('auth/authenticate', {
            strategy: 'local',
            ...user,
          }, { root: true });

          const { locale } = Store.state.auth.user;
          await Store.dispatch('app/setLocale', { $i18n: i18n, locale });
        },

        async hasRights(context, rights) {
          let userRights = _.get(context.state, 'user.rights');
          if (!userRights) {
            if (context.state.isAuthenticatePending) {
              await until(() => context.state.isAuthenticatePending === false);
            } else {
              try {
                await context.dispatch('authenticate');
              } catch (error) {
                return false;
              }
            }
            userRights = _.get(context.state, 'user.rights');
          }

          // is administrator
          if (_.includes(userRights, '*')) {
            return true;
          }

          const r = !_.isArray(rights) ? [rights] : rights;
          const c = _.filter(userRights, x => _.includes(r, x));
          return c.length === r.length;
        },

        isAdmin(context) {
          return _.includes(_.get(context.state, 'user.rights'), '*');
        },
      },
    },
  },
};
